(function () {
    'use strict';

    angular.module('app.n11Integration', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();